import { render, staticRenderFns } from "./frozen_stockTools.vue?vue&type=template&id=bf33634a&scoped=true&"
import script from "./frozen_stockTools.vue?vue&type=script&lang=js&"
export * from "./frozen_stockTools.vue?vue&type=script&lang=js&"
import style0 from "./frozen_stockTools.vue?vue&type=style&index=0&id=bf33634a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf33634a",
  null
  
)

export default component.exports